// extracted by mini-css-extract-plugin
export default {"root":"DoYOwW","icon":"Nynuxn","description":"z51g_H","link":"YOlt5_"};